export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11855.e3126904.jpg";